export default function getImgUrl(name, path) {
  return process.env.VUE_APP_BASE_API + '/authority/user/image?name=' + name + '&path=' + path;
}